import { ModernChicData } from "../../json/modernChic";
import {
  INVITATION_LOADING,
  IS_FROM_PORTFOLIO,
  SET_INVITATION_DETAILS,
  SET_INVITATION_OPEN,
  SET_INVITATION_PREVIEW,
  SET_INVITATION_THEME,
} from "../actions/type";

const initialState = {
 isFromPortfolio: false,
};

const inviteReducer = (state = initialState, action) => {
  switch (action.type) {
    case IS_FROM_PORTFOLIO:
      return {
        ...state,
        isFromPortfolio: action.data || false,
      };

    default:
      return state;
  }
};

export default inviteReducer;
